// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1CkZM","modalFooterButton":"ModalNotes_modalFooterButton__3aVqb"};